import{__awaiter as e,__rest as t}from"../../../../../node_modules/tslib/tslib.es6.js";import{shopifyStorefrontClientWrapper as r}from"../../../../../lib/clients.js";import{handleError as i}from"../../../../../lib/error-handler.js";import{gql as n}from"graphql-request";import{MAILING_ADDRESS_FIELDS as o,BILLING_ADDRESS_FIELDS as s}from"../../fragments/address-fields.js";import{STOREFRONT_METAFIELD_FRAGMENT as l}from"../../fragments/metafields.js";import{PAGE_INFO_FRAGMENT as a}from"../../fragments/page-info.js";import{VARIANT_FIELDS as d}from"../../fragments/variant.js";import{shopifySfOrdersToUnlikelyOrders as u}from"../utils/serializers.js";import{getMetafieldIdentifiers as c}from"../../../../../lib/metafields.js";const f=`\n  title\n  quantity\n  currentQuantity\n  originalTotalPrice {\n    amount\n    currencyCode\n  }\n  discountedTotalPrice {\n    amount\n    currencyCode\n  }\n  variant {\n    ${d}\n  }\n  customAttributes {\n    key\n    value\n  }\n`,m=n`
query getCustomerOrders(
  $customerAccessToken: String!
  $ordersAmount: Int!
  $cursor: String
  $language: LanguageCode
  $country: CountryCode
  $includeMetafields: Boolean!
  $metafieldIdentifiers: [HasMetafieldsIdentifier!]!
  $sortKey: OrderSortKeys = ID
  $storeAvailabilityFirst: Int = 0
  $includeCustomAttributes: Boolean = false
  $includeStoreAvailability: Boolean = false
  $includeVariantsMetafields: Boolean = false
  $includeProductsMetafields: Boolean = false
  $metafieldVariantsIdentifiers: [HasMetafieldsIdentifier!] = []
  $metafieldProductIdentifiers: [HasMetafieldsIdentifier!] = []
  ) @inContext(language: $language, country: $country) {
    customer(customerAccessToken: $customerAccessToken) {
      orders(first: $ordersAmount, after: $cursor, reverse: true, sortKey: $sortKey) {
        ${a}
        nodes {
          id
          name
          email
          customerLocale
          customAttributes @include(if: $includeCustomAttributes) {
            key
            value
          }
          orderNumber
          processedAt
          canceledAt
          financialStatus
          fulfillmentStatus
          metafields(identifiers: $metafieldIdentifiers) @include(if: $includeMetafields) {
            ${l}
          }
          totalPrice {
            amount
            currencyCode
          }
          originalTotalPrice {
            amount
            currencyCode
          }
          currentTotalPrice {
            amount
            currencyCode
          }
          currentSubtotalPrice {
            amount
            currencyCode
          }
          subtotalPrice {
            amount
            currencyCode
          }
          totalShippingPrice {
            amount
            currencyCode
          }
          totalRefunded {
            amount
            currencyCode
          }
          totalTax {
            amount
            currencyCode
          }
          successfulFulfillments(first: 100) {
            trackingCompany
            trackingInfo {
              number
              url
            }
            fulfillmentLineItems(first: 100) {
              nodes {
                quantity
                lineItem {
                  ${f}
                }
              }
            }
          }
          shippingAddress {
            ${o}
          }
          billingAddress {
            ${s}
          }
          lineItems(first: 100, reverse: true) {
            nodes {
              ${f}
            }
          }
        }
      }
    }
  }
`,y=r(((r,n)=>e(void 0,void 0,void 0,(function*(){var e,o,s,l,a,{metafieldKeys:d,productMetafieldKeys:f,variantMetafieldKeys:y,includeCustomAttributes:$=!1,sortKey:g="ID"}=n,v=t(n,["metafieldKeys","productMetafieldKeys","variantMetafieldKeys","includeCustomAttributes","sortKey"]);const p=c(d),C=c(f),b=c(y),I=yield r.request(m,Object.assign({metafieldIdentifiers:p,includeMetafields:p.length>0,metafieldProductIdentifiers:C,includeProductsMetafields:C.length>0,metafieldVariantsIdentifiers:b,includeVariantsMetafields:b.length>0,includeCustomAttributes:$,sortKey:g},v));return{errors:i(null==I?void 0:I.errors),pageInfo:null!==(s=null===(o=null===(e=null==I?void 0:I.customer)||void 0===e?void 0:e.orders)||void 0===o?void 0:o.pageInfo)&&void 0!==s?s:null,orders:(null===(l=null==I?void 0:I.customer)||void 0===l?void 0:l.orders)?u(null===(a=null==I?void 0:I.customer)||void 0===a?void 0:a.orders):[]}}))));export{m as GET_CUSTOMER_ORDERS,f as LINE_ITEM_FIELDS,y as sfCustomerOrders};
//# sourceMappingURL=orders.js.map
